import Cigam from './Cigam'

export default Cigam
